import { ReactNode } from 'react'

export type ReplaceTagProps = {
  info: string
  tagList: { renderComponent: (text: string) => ReactNode; tag: string }[]
}

export const replaceTag = ({ info, tagList }: ReplaceTagProps) => {
  let result: (string | ReactNode)[] = [info]

  tagList.forEach(({ tag, renderComponent }) => {
    result = result
      .map((text) => {
        if (typeof text !== 'string') {
          return text
        }
        return text.split(`<${tag}>`).map((data) => {
          if (data.indexOf(`</${tag}>`) >= 0) {
            const auxi = data.split(`</${tag}>`)

            return [renderComponent(auxi[0]), auxi[1]]
          }
          return data
        })
      })
      .flat(Infinity)
  })

  return result
}
